import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentProfileLookup extends Layout {
    sourceManifestProfile: DataSource;
    tablePartialShipmentProfileLookup: Table;
}
